import configJson from "./AuthConfig.json";

export function getConfig() {
  return {
    idleTimeout: configJson.idleTimeoutInSeconds,
    autloLogout: configJson.autoLogoutInSeconds,
    popUpTitle: configJson.idleTimeoutPopupTitle,
    popUpContent1: configJson.idleTimeoutPopupContent1,
    popUpContent2: configJson.idleTimeoutPopupContent2,
  };
}
